export default "__VITE_ASSET__92d14645__"